// @ts-ignore
import DataCortex from 'browser-data-cortex';

export default DataCortex;
